/**
 * product-slider
 */

import $ from 'jquery';
import 'slick-carousel';
import Page from 'js/lib/page';

export default class ProductSlider extends Page {
  init() {
    this.selectors = {
      container: '.js-product-slider-container',
      thumbnail: '.js-product-slider-thumbnail'
    };

    this.elements({
      container: this.selectors.container,
      thumbnail: this.selectors.thumbnail
    });

    this.slider();
  }
  events() {}
  slider() {
    this.$.container.slick({
      infinite: true,
      dots: false,
      arrows: false,
      autoplaySpeed: 10000,
      autoplay: true,
      asNavFor: this.selectors.thumbnail
    });

    this.$.thumbnail.slick({
      infinite: true,
      dots: false,
      arrows: false,
      slidesToShow: 5,
      focusOnSelect: true,
      asNavFor: this.selectors.container,
      vertical: true,
      verticalSwiping: true,
      accessibility: false
    });
  }
}

Page.make(ProductSlider, '.js-product-slider');
